/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

// Define showColorVariant globally IMMEDIATELY so it's available for onclick handlers
// This must be defined before any HTML with onclick="showColorVariant(event)" is parsed
window.showColorVariant = function showColorVariant(event) {

  if (!event) {
    console.warn('[showColorVariant] Called without event');
    return;
  }

  // Prevent all default behavior and stop propagation immediately
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const clickedColorSwatch = event?.target?.closest("div[data-color-swatch-id]");
  if (!clickedColorSwatch) {
    console.warn('[showColorVariant] No color swatch found');
    return;
  }

  const clickedSwatchId = clickedColorSwatch.getAttribute("data-color-swatch-id");

  const productCardContainer = clickedColorSwatch.closest("product-grid-item");
  if (!productCardContainer) {
    console.warn('[showColorVariant] No product card container found');
    return;
  }

  const swipers = productCardContainer.querySelectorAll(".collection-cardSwiper");
  const imageSets = productCardContainer.querySelectorAll(".collection-cardImageSet");
  let matchedImageSet = null;

  // First, find the matching image set from all image sets
  imageSets.forEach((imageSet) => {
    if (imageSet.getAttribute("data-card-product-id") === clickedSwatchId) {
      matchedImageSet = imageSet;
    }
  });

  if (!matchedImageSet) {
    console.warn('[showColorVariant] No matching image set found for ID:', clickedSwatchId);
    return;
  }


  // Sync immediately - this ensures the title/price update right away
  // Note: syncProductCardToImageSet must be defined before this function is called
  if (typeof syncProductCardToImageSet === "function") {
    syncProductCardToImageSet(productCardContainer, matchedImageSet, clickedColorSwatch);
  } else {
    console.error('[showColorVariant] syncProductCardToImageSet function not found!');
  }

  // Update swiper to show the correct slide
  let swiperUpdated = false;
  swipers.forEach((s, index) => {


    // Check if swiper is initialized
    if (!s.classList.contains("swiper-initialized")) {
      // Try to initialize it
      if (typeof swiperCards === "function") {
        swiperCards("showColorVariant", [s]);
        // Wait a bit for initialization
        setTimeout(() => {
          processSwiperSlide(s, clickedSwatchId, productCardContainer);
        }, 50);
      } else {
        console.error('[showColorVariant] swiperCards function not found!');
      }
      return;
    }

    processSwiperSlide(s, clickedSwatchId, productCardContainer);
  });

  // Handle case where there are no swipers (fallback display)
  if (!swipers.length) {
    imageSets.forEach((imageSet) => {
      if (imageSet === matchedImageSet) {
        imageSet.classList.remove("swiperHidden");
      } else {
        imageSet.classList.add("swiperHidden");
      }
    });
  }

};

// Helper function to process swiper slide changes
function processSwiperSlide(swiperContainer, clickedSwatchId, productCardContainer) {
  const swiperInstance = swiperContainer.swiper;
  if (!swiperInstance || typeof swiperInstance.slideTo !== "function") {
    console.warn('[processSwiperSlide] Invalid swiper instance');
    return;
  }

  const slides = Array.from(swiperInstance.slides);
  if (!slides.length) {
    console.warn('[processSwiperSlide] No slides found');
    return;
  }

  if (typeof getColorRanges !== "function") {
    console.error('[processSwiperSlide] getColorRanges function not found!');
    return;
  }

  const ranges = getColorRanges(slides);
  const range = ranges.find((r) => r.id === clickedSwatchId);


  if (window.innerWidth < 1024 && swiperContainer._cardSwiperState?.slidesByColor) {
    if (typeof setSlidesForColor === "function" && typeof updateNavState === "function") {
      const firstSlide = setSlidesForColor(swiperInstance, swiperContainer, clickedSwatchId);
      if (firstSlide) {
        updateNavState(swiperInstance, swiperContainer);
      }
    }
  } else if (range) {
    // Check if we're already on this slide
    const currentRange = ranges.find((r) => r.id === swiperContainer._cardSwiperState?.currentColorId);
    const isAlreadyOnSlide = currentRange &&
      swiperInstance.activeIndex >= currentRange.start &&
      swiperInstance.activeIndex <= currentRange.end &&
      swiperContainer._cardSwiperState?.currentColorId === clickedSwatchId;


    if (!isAlreadyOnSlide) {

      // Set flag BEFORE any operations to prevent slideChangeTransitionStart from interfering
      swiperContainer.dataset.manualColorChange = "true";

      // Temporarily disable navigation locks to ensure slide can move in any direction
      const originalAllowSlidePrev = swiperInstance.allowSlidePrev;
      const originalAllowSlideNext = swiperInstance.allowSlideNext;
      swiperInstance.allowSlidePrev = true;
      swiperInstance.allowSlideNext = true;

      // Update state BEFORE moving slide
      if (!swiperContainer._cardSwiperState) swiperContainer._cardSwiperState = {};
      swiperContainer._cardSwiperState.currentColorId = clickedSwatchId;
      swiperContainer._cardSwiperState.ranges = ranges;
      swiperContainer._cardSwiperState.lastIndex = range.start;

      // Force immediate slide change - use requestAnimationFrame to ensure DOM is ready
      requestAnimationFrame(() => {
        // Move swiper to the correct slide (instant, no transition, no callbacks)
        swiperInstance.slideTo(range.start, 0, false);
        swiperInstance.updateSlidesClasses();
        swiperInstance.update();

        // Double-check and force again if needed
        requestAnimationFrame(() => {
          const newActiveIndex = swiperInstance.activeIndex;


          // If slide didn't change, force it again more aggressively
          if (newActiveIndex !== range.start) {
            // Reset swiper state and try again
            swiperInstance.allowSlidePrev = true;
            swiperInstance.allowSlideNext = true;
            swiperInstance.slideTo(range.start, 0, false);
            swiperInstance.updateSlidesClasses();
            swiperInstance.update();

            // One more check after a brief delay
            setTimeout(() => {
              const finalIndex = swiperInstance.activeIndex;
              if (finalIndex !== range.start) {
                console.warn('[processSwiperSlide] Slide still not changed after force, final index:', finalIndex);
                // Last resort - directly manipulate the DOM
                const slides = Array.from(swiperInstance.slides);
                if (slides[range.start]) {
                  slides.forEach((slide, idx) => {
                    slide.classList.remove('swiper-slide-active');
                    if (idx === range.start) {
                      slide.classList.add('swiper-slide-active');
                    }
                  });
                  swiperInstance.activeIndex = range.start;
                  swiperInstance.updateSlidesClasses();
                }
              }
            }, 100);
          }

          // Restore original allowSlide settings
          swiperInstance.allowSlidePrev = originalAllowSlidePrev;
          swiperInstance.allowSlideNext = originalAllowSlideNext;

          if (typeof updateNavState === "function") {
            updateNavState(swiperInstance, swiperContainer);
          }
        });
      });

      // Clean up flags after a longer delay to ensure transition completes
      setTimeout(() => {
        delete swiperContainer.dataset.syncing;
        delete swiperContainer.dataset.manualColorChange;
      }, 300);
    } else {
      // Already on correct slide, just ensure state is updated
      if (!swiperContainer._cardSwiperState) swiperContainer._cardSwiperState = {};
      swiperContainer._cardSwiperState.currentColorId = clickedSwatchId;
    }
  } else {
    console.warn('[processSwiperSlide] No range found for clicked swatch ID:', clickedSwatchId);
  }
}

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener("theme:variant:change", function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      if (typeof handleVariantChange == "function") {
        handleVariantChange(variant);
      }
      // ... update some element on the page
    }
  });

  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      if (typeof updateCartCount == "function") {
        updateCartCount(cart);
      }
      if (typeof handleCartRecommendation == "function") {
        handleCartRecommendation(cart);
      }
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener("theme:cart:init", (event) => {
    var cart = event.detail.cart;
    if (cart) {
      if (typeof updateCartCount == "function") {
        updateCartCount(cart);
      }
      if (typeof handleCartRecommendation == "function") {
        handleCartRecommendation(cart);
      }
    }
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // Disable background when quickview modal is open
  let isBackgroundDisabled = false;
  let backgroundClickHandler = null;
  let backgroundTouchHandler = null;
  let savedScrollPosition = 0;
  let scrollRestoreInterval = null;

  function disableBackground() {
    if (isBackgroundDisabled) return; // Prevent duplicate calls
    isBackgroundDisabled = true;

    // Save current scroll position BEFORE any scroll lock is applied
    savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    document.body.classList.add('quickview-modal-open');

    // Lock scroll on mobile devices to prevent background scrolling
    const isMobile = window.innerWidth <= 767;
    if (isMobile) {
      // Prevent background scrolling on mobile
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${savedScrollPosition}px`;
      document.documentElement.style.overflow = 'hidden';

      // Prevent touch scrolling on background
      backgroundTouchHandler = function(e) {
        // Allow touches inside modal
        if (e.target.closest('.quickview__modal')) {
          return;
        }
        // Prevent all other touch moves on background
        e.preventDefault();
      };
      document.addEventListener('touchmove', backgroundTouchHandler, { passive: false });
    }

    // Prevent all background link clicks
    backgroundClickHandler = function(e) {
      // Allow clicks inside modal (including close button)
      if (e.target.closest('.quickview__modal')) {
        return; // Don't block - let it work normally
      }
      // Allow clicks on close button even if outside modal check
      if (e.target.closest('[data-micromodal-close]') ||
          e.target.closest('.drawer__button') ||
          e.target.closest('.drawer__close')) {
        return; // Don't block - let it work normally
      }
      // Block all other clicks on links and buttons in background
      if (e.target.tagName === 'A' ||
          e.target.closest('a[data-grid-link]') ||
          e.target.closest('a[href*="/products/"]') ||
          (e.target.tagName === 'BUTTON' && !e.target.closest('.quickview__modal'))) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    };

    // Add click handler to prevent background interactions
    document.addEventListener('click', backgroundClickHandler, true);
    // Also prevent on links specifically
    const allLinks = document.querySelectorAll('a[data-grid-link], a[href*="/products/"]');
    allLinks.forEach(function(link) {
      link.addEventListener('click', backgroundClickHandler, true);
    });
  }

  function enableBackground() {
    if (!isBackgroundDisabled) return; // Prevent duplicate calls
    isBackgroundDisabled = false;

    // Clear the scroll restore interval
    if (scrollRestoreInterval) {
      clearInterval(scrollRestoreInterval);
      scrollRestoreInterval = null;
    }

    document.body.classList.remove('quickview-modal-open');
    document.querySelector('html').removeAttribute('data-scroll-locked')
    document.body.style.overflow = ''

    // Unlock scroll on mobile devices and restore position
    const isMobile = window.innerWidth <= 767;
    if (isMobile) {
      // Restore scroll position
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      document.documentElement.style.overflow = '';

      // Restore scroll position
      if (savedScrollPosition > 0) {
        window.scrollTo(0, savedScrollPosition);
        savedScrollPosition = 0;
      }
    }

    // Remove touch handler
    if (backgroundTouchHandler) {
      document.removeEventListener('touchmove', backgroundTouchHandler);
      backgroundTouchHandler = null;
    }

    // Remove click handler
    if (backgroundClickHandler) {
      document.removeEventListener('click', backgroundClickHandler, true);
      const allLinks = document.querySelectorAll('a[data-grid-link], a[href*="/products/"]');
      allLinks.forEach(function(link) {
        link.removeEventListener('click', backgroundClickHandler, true);
      });
      backgroundClickHandler = null;
    }
  }

  // Initialize Swiper for quickview modal images on mobile
  let quickviewSwipers = new Map();

  // Styles are now handled by CSS in api-product-quickview.liquid
  // This function is kept as a no-op for backward compatibility
  function applyQuickviewImageStyles(imagesContainer) {
    // CSS handles all styling - no JavaScript needed
    return;
  }

  // Watch for quickview content insertion and apply styles immediately
  function setupQuickviewContentWatcher() {
    // Watch for when modal content is inserted
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Styles are handled by CSS - no JavaScript needed
            }
          });
        }
      });
    });

    // Observe all quickview modals
    document.querySelectorAll('[data-product-quickview-ajax], .quickview__modal').forEach(function(container) {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    });

    // Also observe body for dynamically added modals
    observer.observe(document.body, {
      childList: true,
      subtree: false
    });
  }

  // Initialize watcher on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupQuickviewContentWatcher);
  } else {
    setupQuickviewContentWatcher();
  }

  function initQuickviewSwiper(modal) {
    if (!modal) return;

    // Only initialize on mobile
    if (window.innerWidth > 767) return;

    const imagesContainer = modal.querySelector('.quickview__modal__images.quickview-swiper');
    if (!imagesContainer) return;

    // Styles are handled by CSS - no JavaScript needed

    // Destroy existing swiper if it exists
    if (quickviewSwipers.has(imagesContainer)) {
      const existingSwiper = quickviewSwipers.get(imagesContainer);
      if (existingSwiper && !existingSwiper.destroyed) {
        existingSwiper.destroy(true, true);
      }
      quickviewSwipers.delete(imagesContainer);
    }

    setTimeout(() => {
      // Initialize new Swiper
      if (typeof Swiper !== 'undefined') {
        const swiper = new Swiper(imagesContainer, {
          slidesPerView: 2.5,
          spaceBetween: 8,
          freeMode: true,
          resistance: true,
          resistanceRatio: 0,
          watchOverflow: true,
          grabCursor: true,
          // Enable mouse dragging
          simulateTouch: true,
          allowTouchMove: true,
          // Enable mouse wheel scrolling
          mousewheel: {
            forceToAxis: true,
            sensitivity: 1,
            releaseOnEdges: false,
          },
        });

        quickviewSwipers.set(imagesContainer, swiper);
      }
    }, 0)
  }

  function destroyQuickviewSwiper(modal) {
    if (!modal) return;

    const imagesContainer = modal.querySelector('.quickview__modal__images.quickview-swiper');
    if (!imagesContainer) return;

    if (quickviewSwipers.has(imagesContainer)) {
      const swiper = quickviewSwipers.get(imagesContainer);
      if (swiper && !swiper.destroyed) {
        swiper.destroy(true, true);
      }
      quickviewSwipers.delete(imagesContainer);
    }
  }

  // Function to check modal state and update background
  function checkModalState(modal) {
    if (!modal || !modal.classList.contains('quickview__modal')) return;

    const isOpen = modal.classList.contains('is-open') ||
                   modal.classList.contains('drawer--visible') ||
                   modal.getAttribute('aria-hidden') === 'false';

    if (isOpen) {
      disableBackground();
      // Styles are handled by CSS in api-product-quickview.liquid - no JavaScript needed

      // Initialize variant selection handlers when modal opens
      setTimeout(function() {
        setupQuickviewVariantSelection(modal);
      }, 100);

      // Initialize Swiper when modal opens (reduced delay for faster initialization)
      setTimeout(function() {
        initQuickviewSwiper(modal);
      }, 50);
    } else {
      enableBackground();
      // Destroy Swiper when modal closes
      destroyQuickviewSwiper(modal);
    }
  }

  // Ensure close button always works - only closes modal, no other actions
  function setupCloseButtonHandler() {
    document.addEventListener('click', function(e) {
      const closeButton = e.target.closest('[data-micromodal-close]') ||
                          e.target.closest('.drawer__close') ||
                          e.target.closest('.drawer__button.drawer__close');

      if (closeButton) {
        const modal = closeButton.closest('.quickview__modal');
        if (modal) {
          // Prevent all default actions and stop propagation
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          // Only close the modal, nothing else
          if (typeof window.MicroModal !== 'undefined') {
            const modalId = modal.id;
            if (modalId) {
              window.MicroModal.close(modalId);
            }
          }

          // Return false as additional safeguard
          return false;
        }
      }
    }, true); // Use capture phase to ensure it runs first
  }

  // Listen for quickview modal open/close
  function initModalObserver() {
    // Setup close button handler
    setupCloseButtonHandler();

    // Use MutationObserver to watch for modal state changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        const modal = mutation.target;
        if (modal.classList && modal.classList.contains('quickview__modal')) {
          checkModalState(modal);
        }
      });
    });

    // Observe all quickview modals
    const modals = document.querySelectorAll('.quickview__modal');
    modals.forEach(function(modal) {
      observer.observe(modal, {
        attributes: true,
        attributeFilter: ['aria-hidden', 'class']
      });

      // Initial check
      checkModalState(modal);
    });

    // Also watch for dynamically added modals
    const bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains('quickview__modal')) {
            observer.observe(node, {
              attributes: true,
              attributeFilter: ['aria-hidden', 'class']
            });
            checkModalState(node);
          }
        });
      });
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModalObserver);
  } else {
    initModalObserver();
  }
})();

(function checkSortBy() {
  let sortBy = window.location.href.includes('sort_by=') ? window.location.href.split('sort_by=')[1].split('&')[0] : '';

  let sortButtonText = document.querySelector('[data-sort-button-text]');

  if (sortButtonText && sortBy) {
    sortButtonText.innerHTML = sortBy;
  }
})();

function createSlidesFromJson(swiperContainer, slidesData) {
  try {
    // Parse the JSON data from the div content
    const jsonText = slidesData.textContent.trim();
    if (!jsonText) return;

    // Wrap in array brackets if not already an array
    const jsonArray = jsonText.startsWith('[') ? jsonText : `[${jsonText}]`;
    const images = JSON.parse(jsonArray);

    const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
    if (!swiperWrapper) return;

    // Create slides for each image
    images.forEach((image, index) => {
      const slide = document.createElement('div');
      slide.className = 'new_card_product_media swiper-slide inside-swiper-images';

      const img = document.createElement('img');
      // Generate srcset from the base image URL
      const baseUrl = image.src.split('?')[0]; // Remove query parameters
      const queryParams = image.src.split('?')[1]; // Get query parameters
      const srcset = `${baseUrl}?${queryParams}&width=100 100w, ${baseUrl}?${queryParams}&width=352 352w`;

      img.srcset = srcset;
      img.src = image.src;
      img.alt = image.alt;
      img.sizes = image.sizes;
      img.loading = 'lazy';
      img.fetchpriority = 'low';
      img.className = 'motion-reduce media_product';
      img.setAttribute('width', '100%');
      img.setAttribute('height', '100%');

      slide.appendChild(img);
      swiperWrapper.appendChild(slide);
    });

    // Remove the JSON data div after creating slides
    slidesData.remove();
  } catch (error) {
    console.error('Error parsing slides JSON:', error);
  }
}

function getColorRanges(slides) {
  const ranges = [];
  let currentId = null;
  let start = 0;
  slides.forEach((slide, idx) => {
    const pid = slide.getAttribute("data-card-product-id");
    if (pid !== currentId) {
      if (currentId !== null) ranges.push({ id: currentId, start, end: idx - 1 });
      currentId = pid;
      start = idx;
    }
    if (idx === slides.length - 1 && currentId !== null) {
      ranges.push({ id: currentId, start, end: idx });
    }
  });
  return ranges;
}

function buildColorSlideMap(slides) {
  const map = {};
  slides.forEach((slide) => {
    const pid = slide.getAttribute("data-card-product-id");
    if (!pid) return;
    if (!map[pid]) map[pid] = [];
    map[pid].push(slide.cloneNode(true));
  });
  return map;
}

function updateNavState(swiper, container) {
  if (!swiper || !swiper.slides || !swiper.params.navigation) return;
  const prev = swiper.params.navigation.prevEl;
  const next = swiper.params.navigation.nextEl;

  let atStart = swiper.activeIndex === 0;
  let atEnd = swiper.activeIndex === swiper.slides.length - 1;

  // On desktop, lock within current color range
  if (container?._cardSwiperState && window.innerWidth >= 1024) {
    const { ranges, currentColorId } = container._cardSwiperState;
    const range = ranges?.find((r) => r.id === currentColorId);
    if (range) {
      atStart = swiper.activeIndex <= range.start;
      atEnd = swiper.activeIndex >= range.end;
    }
  }

  if (prev) {
    prev.classList.toggle("swiper-button-disabled", atStart);
    prev.setAttribute("aria-disabled", atStart ? "true" : "false");
  }
  if (next) {
    next.classList.toggle("swiper-button-disabled", atEnd);
    next.setAttribute("aria-disabled", atEnd ? "true" : "false");
  }

  // Block navigation when at the ends
  swiper.allowSlidePrev = !atStart;
  swiper.allowSlideNext = !atEnd;
}

function setSlidesForColor(swiper, container, colorId) {
  if (!swiper || !container || !colorId) return null;
  const state = container._cardSwiperState;
  if (!state || !state.slidesByColor) return null;
  const slides = state.slidesByColor[colorId];
  if (!slides || !slides.length) return null;

  swiper.removeAllSlides();
  // Clone again to avoid DOM re-use issues
  swiper.appendSlide(slides.map((s) => s.cloneNode(true)));
  swiper.slideTo(0, 0);

  state.currentColorId = colorId;
  state.lastIndex = 0;
  updateNavState(swiper, container);

  return swiper.slides[0];
}

function syncProductCardToImageSet(productCardContainer, imageSet, swatchElement = null) {
  if (!productCardContainer || !imageSet) return;

  const setProductId = imageSet.getAttribute("data-card-product-id");
  const setProductTitle = imageSet.getAttribute("data-product-title");
  const setProductPrice = imageSet.getAttribute("data-product-price");
  const setProductCompare = imageSet.getAttribute("data-product-compare-price");
  const handleFromSlide = imageSet.getAttribute("data-product-handle");
  const swatch = swatchElement || (setProductId ? productCardContainer.querySelector(`[data-color-swatch-id="${setProductId}"]`) : null);
  const handleFromSwatch = swatch ? swatch.getAttribute("data-color-swatch-handle") : null;
  const productHandle = handleFromSwatch || handleFromSlide;

  const titleEl = productCardContainer.querySelector(".product__grid__title");
  if (titleEl && setProductTitle) {
    titleEl.textContent = setProductTitle;
  }

  const priceEl = productCardContainer.querySelector(".product__grid__price .price");
  if (priceEl && setProductPrice) {
    priceEl.textContent = setProductPrice;
    priceEl.classList.toggle("on-sale", Boolean(setProductCompare));
  }

  const compareEl = productCardContainer.querySelector(".product__grid__price .compare-at");
  if (compareEl) {
    if (setProductCompare) {
      compareEl.textContent = setProductCompare;
      compareEl.style.display = "";
    } else {
      compareEl.textContent = "";
      compareEl.style.display = "none";
    }
  }

  const productLink = productCardContainer.querySelector("a[data-grid-link]");
  if (productLink && productHandle) {
    productLink.setAttribute("href", `/products/${productHandle}`);
    productLink.setAttribute("data-product-url", productHandle);
    productLink.setAttribute("aria-label", setProductTitle || productHandle);
  }

  // Update quickview button and holder to use the current product variant
  const quickviewIcon = productCardContainer.querySelector(".product__grid__quickview-icon");
  if (quickviewIcon && setProductId && productHandle) {
    quickviewIcon.setAttribute("data-product-id", setProductId);
    quickviewIcon.setAttribute("data-product-handle", productHandle);

    // Also update the quickview holder's data-product-handle
    const quickviewHolder = productCardContainer.querySelector(`[data-quickview-holder="${setProductId}"]`);
    if (quickviewHolder) {
      quickviewHolder.setAttribute("data-product-handle", productHandle);
    } else {
      // If holder doesn't exist for this product ID, try to find any holder and update it
      const anyQuickviewHolder = productCardContainer.querySelector("[data-quickview-holder]");
      if (anyQuickviewHolder) {
        anyQuickviewHolder.setAttribute("data-product-handle", productHandle);
        anyQuickviewHolder.setAttribute("data-quickview-holder", setProductId);
      }
    }
  }

  if (setProductId) {
    productCardContainer.querySelectorAll("div[data-color-swatch-id]").forEach((colorSwatch) => {
      colorSwatch.classList.remove("colorSwatchBorder");
    });

    if (swatch) {
      swatch.classList.add("colorSwatchBorder");
    }
  }

  if (setProductId) {
    productCardContainer.querySelectorAll("[data-size-toolbar]").forEach((el) => {
      el.setAttribute("hidden", "");
    });
    const activeToolbar = productCardContainer.querySelector(`[data-size-toolbar="${setProductId}"]`);
    if (activeToolbar) {
      activeToolbar.removeAttribute("hidden");
    }
  }

  const visibleImg = imageSet.querySelector("img");
  if (visibleImg && visibleImg.dataset.originalSrc) {
    visibleImg.setAttribute("src", visibleImg.dataset.originalSrc);
    if (visibleImg.dataset.originalSrcset) {
      visibleImg.setAttribute("srcset", visibleImg.dataset.originalSrcset);
    }
    delete visibleImg.dataset.originalSrc;
    delete visibleImg.dataset.originalSrcset;
  }
}

function swiperCards(whoCalledThis, swiperContainers = document.querySelectorAll(".collection-cardSwiper")) {
  if (typeof Swiper === "undefined") return;

  swiperContainers.forEach((container) => {
    if (!container || container.classList.contains("swiper-initialized")) return;

    const slidesData = container.querySelector("[data-slides-json]");
    if (slidesData) {
      createSlidesFromJson(container, slidesData);
    }

    const wrapper = container.querySelector(".swiper-wrapper");
    if (!wrapper) return;

    const slides = wrapper.querySelectorAll(".collection-cardImageSet");
    if (!slides.length) return;

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
      slide.classList.remove("swiperHidden");
    });

    let paginationEl = container.querySelector(".swiper-pagination");
    if (!paginationEl) {
      paginationEl = document.createElement("div");
      paginationEl.className = "swiper-pagination";
      container.appendChild(paginationEl);
    }

    let prevEl = container.querySelector(".swiper-button-prev");
    let nextEl = container.querySelector(".swiper-button-next");
    if (!prevEl) {
      prevEl = document.createElement("div");
      prevEl.className = "swiper-button-prev";
      prevEl.setAttribute("aria-label", "Previous slide");
      container.appendChild(prevEl);
    }
    if (!nextEl) {
      nextEl = document.createElement("div");
      nextEl.className = "swiper-button-next";
      nextEl.setAttribute("aria-label", "Next slide");
      container.appendChild(nextEl);
    }

    const productImages = container.closest(".product-grid-item__images");
    if (productImages) {
      productImages.classList.add("has-swiper");
    }

    const slidesArray = Array.from(slides);
    const ranges = getColorRanges(slidesArray);
    const defaultId = slidesArray[0]?.getAttribute("data-card-product-id");

    setTimeout(() => {
      const swiper = new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        watchOverflow: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl,
          prevEl,
        },
        on: {
          init(sw) {
            const card = container.closest("product-grid-item");
            if (!card) return;

            // Get the current product ID from the product-grid-item element
            const currentProductId = card.getAttribute("data-item-id");

            // Find the slide that matches the current product ID
            let activeSet = null;
            let activeIndex = sw.activeIndex;

            if (currentProductId) {
              const matchingSlideIndex = slidesArray.findIndex(slide => {
                const slideProductId = slide.getAttribute("data-card-product-id");
                return slideProductId === currentProductId;
              });

              if (matchingSlideIndex !== -1) {
                activeSet = slidesArray[matchingSlideIndex];
                activeIndex = matchingSlideIndex;
                // Update swiper to show the correct slide
                if (sw.activeIndex !== activeIndex) {
                  sw.slideTo(activeIndex, 0);
                  sw.updateSlidesClasses();
                }
              }
            }

            // Fallback to the first slide if no match found
            if (!activeSet) {
              activeSet = sw.slides[sw.activeIndex];
              activeIndex = sw.activeIndex;
            }

            // Update defaultId to match the current product if we found a match
            const actualDefaultId = activeSet?.getAttribute("data-card-product-id") || defaultId;
            const slidesByColor = buildColorSlideMap(slidesArray);

            container._cardSwiperState = {
              currentColorId: actualDefaultId,
              ranges,
              lastIndex: activeIndex,
              slidesByColor,
            };

            // On mobile, only keep slides for the current color
            if (window.innerWidth < 1024 && actualDefaultId) {
              const firstSlide = setSlidesForColor(sw, container, actualDefaultId);
              if (firstSlide) {
                syncProductCardToImageSet(card, firstSlide);
                updateNavState(sw);
                return;
              }
            }

            syncProductCardToImageSet(card, activeSet);
            updateNavState(sw, container);
          },
          slideChange(sw) {
            const state = container._cardSwiperState;
            if (!state) return;
            // On desktop, keep within current color range
            if (window.innerWidth >= 1024) {
              const range = state.ranges.find((r) => r.id === state.currentColorId);
              if (range) {
                let target = sw.activeIndex;
                if (sw.activeIndex < range.start) target = range.start;
                if (sw.activeIndex > range.end) target = range.end;
                if (target !== sw.activeIndex) {
                  container.dataset.syncing = "true";
                  sw.slideTo(target, 0);
                  sw.updateSlidesClasses();
                  requestAnimationFrame(() => delete container.dataset.syncing);
                }
              }
            }
            updateNavState(sw, container);
          },
          slideChangeTransitionStart(sw) {
            const state = container._cardSwiperState;
            if (!state) return;

            // Skip syncing if we're manually changing colors via showColorVariant
            if (container.dataset.manualColorChange === "true") {
              return;
            }

            const card = container.closest("product-grid-item");
            const activeSet = sw.slides[sw.activeIndex];
            const activeId = activeSet?.getAttribute("data-card-product-id");

            // Prevent crossing into other colors on desktop; snap back to edge of range
            if (window.innerWidth >= 1024 && activeId && activeId !== state.currentColorId) {
              const range = state.ranges.find((r) => r.id === state.currentColorId);
              if (range) {
                const goTo = sw.activeIndex > state.lastIndex ? range.end : range.start;
                container.dataset.syncing = "true";
                sw.slideTo(goTo, 0);
                sw.updateSlidesClasses();
                requestAnimationFrame(() => delete container.dataset.syncing);
                updateNavState(sw, container);
                return;
              }
            }

            state.lastIndex = sw.activeIndex;
            syncProductCardToImageSet(card, activeSet);
            updateNavState(sw, container);
          },
        },
      });
      container.swiper = swiper;
    }, 15)
  });
}

function recordQuickviewSwatchOrder(modal) {
  if (!modal) return;
  const handles = Array.from(modal.querySelectorAll("[data-quickview-color-product-handle]")).map((el) =>
    el.getAttribute("data-quickview-color-product-handle")
  );
  if (handles.length) {
    modal.dataset.swatchOrder = handles.join(",");
  }
}

function applyQuickviewSwatchOrder(modal) {
  if (!modal || !modal.dataset.swatchOrder) return;
  const order = modal.dataset.swatchOrder.split(",").filter(Boolean);
  if (!order.length) return;

  const containers = modal.querySelectorAll(".swatch-container");
  containers.forEach((container) => {
    const swatchDivs = Array.from(container.querySelectorAll(".swatch-image-container"));
    if (!swatchDivs.length) return;

    const map = new Map();
    swatchDivs.forEach((div) => {
      const link = div.querySelector("[data-quickview-color-product-handle]");
      if (link) {
        map.set(link.getAttribute("data-quickview-color-product-handle"), div);
      }
    });

    order.forEach((handle) => {
      const div = map.get(handle);
      if (div) {
        container.appendChild(div);
        map.delete(handle);
      }
    });

    map.forEach((div) => container.appendChild(div));
  });
}

// showColorVariant is now defined at the top of the file for immediate availability

// Handle color swatch clicks inside the Quick View modal.
// We fetch the quickview HTML for the selected colour and replace the modal
// content in place so images + details always match the swatch order.
document.addEventListener("click", function (event) {
  // Ignore clicks on the + MORE button
  if (event.target.closest("a.quickview-more-button")) {
    return;
  }

  const swatchLink = event.target.closest("a[data-quickview-color-swatch]");
  if (!swatchLink) return;

  event.preventDefault();

  const targetHandle = swatchLink.getAttribute("data-quickview-color-product-handle");
  if (!targetHandle) return;

  const modal = swatchLink.closest(".quickview__modal");
  if (!modal) return;

  // Capture the current swatch order so we can reapply it after re-render.
  recordQuickviewSwatchOrder(modal);

  const modalContent = modal.querySelector("[data-product-quickview-ajax]");
  if (!modalContent) return;

  // Optional: add a lightweight loading state on the modal while we swap content
  modal.classList.add("is-loading");

  fetch(`${window.theme.routes.root_url}products/${targetHandle}?section_id=api-product-quickview`)
    .then((response) => response.text())
    .then((html) => {
      const temp = document.createElement("div");
      temp.innerHTML = html;
      const freshContent = temp.querySelector("[data-api-content]");
      if (freshContent) {
        modalContent.innerHTML = freshContent.innerHTML;
        applyQuickviewSwatchOrder(modal);

        // Reinitialize variant selection handlers after content loads (with delay to override theme)
        setTimeout(function() {
          setupQuickviewVariantSelection(modal);
        }, 150);

        // Styles are handled by CSS in api-product-quickview.liquid - no JavaScript needed

        // Initialize Swiper after content is loaded (reduced delay)
        setTimeout(function() {
          initQuickviewSwiper(modal);
        }, 50);
      }
    })
    .catch((error) => {
      console.error("Error loading quickview colour variant:", error);
    })
    .finally(() => {
      modal.classList.remove("is-loading");
    });
});

// Function to handle + MORE button click and redirect to PDP
function handleQuickviewMoreButtonClick(event, button) {
  // Stop event propagation to prevent other handlers from intercepting
  if (event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
  }

  const modal = button.closest(".quickview__modal");
  const productUrl = button.getAttribute('href') || button.href;

  if (productUrl && modal) {
    // Close the modal if possible
    try {
      if (typeof window.MicroModal !== 'undefined') {
        const modalId = modal.id;
        if (modalId) {
          window.MicroModal.close(modalId);
        }
      }
    } catch(e) {
      // Ignore errors
    }

    // Navigate to PDP immediately
    window.location.href = productUrl;
    return false;
  }
  return true;
}

// Handle + MORE button click in quickview modal - redirect to PDP
document.addEventListener("click", function (event) {
  // Check if the clicked element or its parent is the + MORE button
  const moreButton = event.target.closest("a.quickview-more-button") ||
                      (event.target.classList && event.target.classList.contains('quickview-more-button') ? event.target : null);

  if (!moreButton) return;

  handleQuickviewMoreButtonClick(event, moreButton);
}, true); // Use capture phase to run before other handlers

// Also handle touch events for mobile
document.addEventListener("touchend", function (event) {
  const moreButton = event.target.closest("a.quickview-more-button") ||
                      (event.target.classList && event.target.classList.contains('quickview-more-button') ? event.target : null);

  if (!moreButton) return;

  handleQuickviewMoreButtonClick(event, moreButton);
}, true);

// Also attach direct click handlers to buttons when they're added to DOM
function attachQuickviewMoreButtonHandlers() {
  document.querySelectorAll("a.quickview-more-button").forEach(function(button) {
    if (!button.dataset.handlerAttached) {
      button.dataset.handlerAttached = 'true';
      button.addEventListener('click', function(e) {
        handleQuickviewMoreButtonClick(e, button);
      }, true);
      button.addEventListener('touchend', function(e) {
        handleQuickviewMoreButtonClick(e, button);
      }, true);
    }
  });
}

// Run on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', attachQuickviewMoreButtonHandlers);
} else {
  attachQuickviewMoreButtonHandlers();
}

// Also run when new content is added (for dynamically loaded quickview modals)
const quickviewObserver = new MutationObserver(function(mutations) {
  attachQuickviewMoreButtonHandlers();
});

quickviewObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Handle variant selection in quickview modal - enable ATC button when variant is selected
function setupQuickviewVariantSelection(modal) {
  if (!modal) return;

  const atcButton = modal.querySelector('.quickview-atc-button');
  const variantIdInput = modal.querySelector('[data-variant-id-input]');
  const form = modal.querySelector('[data-product-form]');

  if (!atcButton || !variantIdInput || !form) {
    return;
  }

  // Check if all options are selected
  function checkAllOptionsSelected() {
    const optionInputs = Array.from(form.querySelectorAll('input[type="radio"][name^="options"]'));
    if (optionInputs.length === 0) return true; // No options means product has only default variant

    const optionGroups = {};
    optionInputs.forEach(function(input) {
      if (!optionGroups[input.name]) {
        optionGroups[input.name] = [];
      }
      optionGroups[input.name].push(input);
    });

    // Check if at least one option is selected in each group
    const allSelected = Object.keys(optionGroups).every(function(optionName) {
      return optionGroups[optionName].some(function(input) {
        return input.checked;
      });
    });

    return allSelected;
  }

  // Function to clear option value display
  function clearOptionValueDisplay() {
    const optionValueSpans = modal.querySelectorAll('[data-option-value]');
    optionValueSpans.forEach(function(span) {
      // Check if any option is selected
      const hasSelectedOption = form.querySelector('input[type="radio"][name^="options"]:checked');
      if (!hasSelectedOption) {
        span.textContent = '';
      }
    });
  }

  // Uncheck all radio buttons initially in quickview and clear display
  function resetQuickviewOptions() {
    const allRadioButtons = form.querySelectorAll('input[type="radio"][name^="options"]');
    allRadioButtons.forEach(function(radio) {
      radio.checked = false;
      radio.removeAttribute('checked');
    });
    clearOptionValueDisplay();
    atcButton.disabled = true;
    variantIdInput.value = '';

    // Also clear any Alpine.js reactive state if present
    if (window.Alpine && atcButton.closest('[x-data]')) {
      const alpineComponent = atcButton.closest('[x-data]');
      if (alpineComponent.__x) {
        // Try to reset variant state
        try {
          alpineComponent.__x.$data.selectedVariant = null;
        } catch(e) {}
      }
    }
  }

  // Reset immediately
  resetQuickviewOptions();

  // Reset multiple times to override theme's auto-selection
  [100, 300, 500, 1000].forEach(function(delay) {
    setTimeout(function() {
      if (!checkAllOptionsSelected()) {
        resetQuickviewOptions();
      }
    }, delay);
  });

  // Prevent form submission when button is disabled
  const formSubmitHandler = function(event) {
    if (atcButton.disabled || !variantIdInput.value) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
  };
  form.addEventListener('submit', formSubmitHandler, true); // Use capture phase

  // Also prevent button click directly
  atcButton.addEventListener('click', function(event) {
    if (atcButton.disabled || !variantIdInput.value) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
  }, true);

  // Listen for variant changes via theme event
  form.addEventListener('theme:variant:change', function(event) {
    const variant = event.detail.variant;
    if (variant && variant.id) {
      variantIdInput.value = variant.id;
      atcButton.disabled = !variant.available;
    } else {
      atcButton.disabled = true;
      variantIdInput.value = '';
      clearOptionValueDisplay();
    }
  });

  // Listen for direct input changes
  form.addEventListener('change', function(event) {
    if (event.target.matches('input[type="radio"][name^="options"]')) {
      setTimeout(function() {
        if (checkAllOptionsSelected()) {
          // All options selected, let theme handle variant selection
          return;
        } else {
          // Not all selected, reset
          resetQuickviewOptions();
        }
      }, 100);
    }
  });

  // Watch for any checked attributes being added
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
        const target = mutation.target;
        if (target.matches('input[type="radio"][name^="options"]')) {
          if (!checkAllOptionsSelected()) {
            setTimeout(function() {
              resetQuickviewOptions();
            }, 50);
          }
        }
      }
    });
  });

  // Observe all radio buttons
  form.querySelectorAll('input[type="radio"][name^="options"]').forEach(function(radio) {
    observer.observe(radio, {
      attributes: true,
      attributeFilter: ['checked']
    });
  });
}

// Setup variant selection when quickview modal content is loaded
function initQuickviewVariantHandlers() {
  document.querySelectorAll('.quickview__modal').forEach(function(modal) {
    if (!modal.hasAttribute('data-variant-handler-setup')) {
      modal.setAttribute('data-variant-handler-setup', 'true');
      setupQuickviewVariantSelection(modal);
    }
  });
}

// Initialize on DOM ready and when new quickview content is added
document.addEventListener('DOMContentLoaded', initQuickviewVariantHandlers);

// Watch for new quickview modals
const quickviewVariantObserver = new MutationObserver(function(mutations) {
  initQuickviewVariantHandlers();
});

quickviewVariantObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Hover swap for first/second image on card
function initHoverImageSwap() {
  document.querySelectorAll("product-grid-item:not([data-hover-init])").forEach((card) => {
    card.setAttribute("data-hover-init", "true");
    const imageContainer = card.querySelector(".product-grid-item__images");
    if (!imageContainer) return;

    const getVisibleImage = () => {
      const swiperContainer = imageContainer.querySelector(".collection-cardSwiper");
      if (swiperContainer) {
        const activeSlideImg =
          swiperContainer.querySelector(".swiper-slide-active img") ||
          swiperContainer.querySelector(".swiper-slide img");
        if (activeSlideImg) return activeSlideImg;
      }

      const visibleImageSet =
        imageContainer.querySelector(".collection-cardImageSet:not(.swiperHidden)") ||
        imageContainer.querySelector(".collection-cardImageSet");
      return visibleImageSet ? visibleImageSet.querySelector("img") : null;
    };

    const handleMouseEnter = () => {
      const currentImg = getVisibleImage();
      if (!currentImg) return;

      // Make sure image is loaded and visible
      if (!currentImg.complete || currentImg.naturalWidth === 0) {
        // Wait for image to load
        currentImg.addEventListener('load', handleMouseEnter, { once: true });
        return;
      }

      const hoverSrc = currentImg.getAttribute("data-hover-src");
      if (!hoverSrc || hoverSrc === "" || hoverSrc === "null") return;

      // Store original src and srcset if not already stored
      if (!currentImg.dataset.originalSrc) {
        const currentSrc = currentImg.getAttribute("src");
        if (currentSrc && currentSrc !== hoverSrc) {
          currentImg.dataset.originalSrc = currentSrc;
          currentImg.dataset.originalSrcset = currentImg.getAttribute("srcset") || "";
        } else {
          // If src is already the hover src, don't swap
          return;
        }
      }

      // Swap to hover image (use same srcset pattern if available)
      currentImg.setAttribute("src", hoverSrc);
      // Generate srcset for hover image if original had srcset
      if (currentImg.dataset.originalSrcset && currentImg.dataset.originalSrcset !== "") {
        const baseUrl = hoverSrc.split("?")[0];
        const params = hoverSrc.split("?")[1] || "";
        const srcset = `${baseUrl}?${params}&width=100 100w, ${baseUrl}?${params}&width=352 352w, ${baseUrl}?${params}&width=700 700w`;
        currentImg.setAttribute("srcset", srcset);
      } else {
        // Remove srcset if original didn't have one
        currentImg.removeAttribute("srcset");
      }
    };

    const handleMouseLeave = () => {
      const currentImg = getVisibleImage();
      if (!currentImg) return;

      if (currentImg.dataset.originalSrc) {
        currentImg.setAttribute("src", currentImg.dataset.originalSrc);
        if (currentImg.dataset.originalSrcset) {
          currentImg.setAttribute("srcset", currentImg.dataset.originalSrcset);
        }
      }
    };

    card.addEventListener("mouseenter", handleMouseEnter);
    card.addEventListener("mouseleave", handleMouseLeave);
  });
}

// Initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHoverImageSwap);
} else {
  initHoverImageSwap();
}

// Re-initialize when new products are loaded (for infinite scroll, etc.)
const observer = new MutationObserver(() => {
  initHoverImageSwap();
});
observer.observe(document.body, { childList: true, subtree: true });

// Lightweight toast for add-to-cart success
function bayseShowToast(message = "Added to cart successfully.") {
  const existing = document.getElementById("bayse-toast");
  if (existing) {
    existing.textContent = message;
    existing.classList.add("visible");
    clearTimeout(existing._timer);
    existing._timer = setTimeout(() => {
      if (existing && existing.parentNode) {
        existing.classList.remove("visible");
      }
    }, 2000);
    return;
  }
  const toast = document.createElement("div");
  toast.id = "bayse-toast";
  toast.textContent = message;
  toast.style.position = "fixed";
  toast.style.left = "50%";
  toast.style.bottom = "24px";
  toast.style.transform = "translateX(-50%)";
  toast.style.background = "rgba(0,0,0,0.85)";
  toast.style.color = "#fff";
  toast.style.padding = "10px 14px";
  toast.style.borderRadius = "4px";
  toast.style.fontSize = "12px";
  toast.style.zIndex = "9999";
  toast.style.opacity = "0";
  toast.style.transition = "opacity .25s ease";
  document.body.appendChild(toast);
  requestAnimationFrame(() => {
    if (toast && toast.style) {
      toast.style.opacity = "1";
    }
  });
  toast.classList.add("visible");
  toast._timer = setTimeout(() => {
    if (toast && toast.style) {
      toast.style.opacity = "0";
      setTimeout(() => {
        if (toast && toast.parentNode) {
          toast.remove();
        }
      }, 300);
    }
  }, 2000);
}
document.addEventListener("theme:cart:popdown", () => bayseShowToast("Added to cart successfully."));

let drawerToggle = document.querySelectorAll('[data-drawer-toggle="hamburger"]');
if (drawerToggle.length > 0) {
  drawerToggle.forEach((toggleButton) => {
    toggleButton.addEventListener('click', (event) => {
      let smileUIContainer = document.querySelector('#smile-ui-lite-container');
      if (smileUIContainer) {
        if (smileUIContainer.style.display !== 'none') {
          smileUIContainer.style.display = 'none';
        } else {
          smileUIContainer.style.display = null;
        }
      }
      let chatContainer = document.querySelector('#shopify-chat');
      if (chatContainer) {
        if (chatContainer.style.display !== 'none') {
          chatContainer.style.display = 'none';
        } else {
          chatContainer.style.display = null;
        }
      }
    });
  });
}

if(window.innerWidth < 767) {
  let intervalIDSHopifyChat = null;
  let attempts = 0;
  const maxAttempts = 50; // Stop after 5 seconds (50 * 100ms)
  let isCleared = false;

  intervalIDSHopifyChat = setInterval(() => {
    // Double-check if interval was already cleared
    if (isCleared) {
      return;
    }

    attempts++;

    // Stop if we've tried too many times
    if (attempts > maxAttempts) {
      isCleared = true;
      if (intervalIDSHopifyChat) {
        clearInterval(intervalIDSHopifyChat);
        intervalIDSHopifyChat = null;
      }
      return;
    }

    try {
      // Select the element to which you want to attach the shadow root
      const hostElement = document.querySelector('#shopify-chat');
      if (hostElement) {
        const chatElement = hostElement.querySelector('inbox-online-store-chat');
        if (chatElement) {
          // Check if style property exists before accessing
          if (chatElement.style && typeof chatElement.style.transformOrigin !== 'undefined') {
            chatElement.style.transformOrigin = 'center';
            chatElement.style.transform = 'scale(0.7)';
            isCleared = true;
            if (intervalIDSHopifyChat) {
              clearInterval(intervalIDSHopifyChat);
              intervalIDSHopifyChat = null;
            }
          }
        }
      }
    } catch (e) {
      // Any error - clear interval immediately
      isCleared = true;
      if (intervalIDSHopifyChat) {
        clearInterval(intervalIDSHopifyChat);
        intervalIDSHopifyChat = null;
      }
    }
  }, 100);
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    swiperCards("DOMContentLoaded");
  },
  { once: true }
);

// Initialize swipers when related products are loaded dynamically
document.addEventListener('theme:related-products:added', function(event) {
  // The event target is the [data-related-section] element itself
  const relatedSection = event.target;
  if (relatedSection && relatedSection.hasAttribute('data-related-section')) {
    // Use setTimeout to ensure DOM is fully updated
    setTimeout(() => {
      const uninitializedSwipers = relatedSection.querySelectorAll('.collection-cardSwiper:not(.swiper-initialized)');
      if (uninitializedSwipers.length > 0) {
        swiperCards("theme:related-products:added", uninitializedSwipers);
      }
    }, 0);
  }
});

// Initialize swipers when recently viewed products are loaded dynamically
document.addEventListener('theme:recent-products:added', function(event) {
  // The event target is the container element (section-recent-products or related section)
  const container = event.target;
  if (container) {
    // Use setTimeout to ensure DOM is fully updated
    setTimeout(() => {
      // Find all uninitialized swipers in the recently viewed products section
      const uninitializedSwipers = container.querySelectorAll('.collection-cardSwiper:not(.swiper-initialized)');
      if (uninitializedSwipers.length > 0) {
        swiperCards("theme:recent-products:added", uninitializedSwipers);
      }
    }, 0);
  }
});

// Handle quick view icon click in product grid title
// Use capture phase to catch the event before it bubbles to parent links
document.addEventListener('click', function(event) {
  const quickviewIcon = event.target.closest('.product__grid__quickview-icon');
  if (quickviewIcon) {
    // Prevent default and stop propagation immediately
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    // Close header search modal first so underlay/blur and scroll lock clear before quick view opens
    const searchContainer = document.querySelector('.predictive-search-modal__wrap')
    if(searchContainer){
      searchContainer.querySelector('#search-popdown').classList.remove('is-visible');
      searchContainer.querySelector('.drawer__underlay').classList.remove('underlay--visible');
    }

    const productId = quickviewIcon.getAttribute('data-product-id');
    const productHandle = quickviewIcon.getAttribute('data-product-handle');

    if (productId && productHandle) {
      // Find the quickview button in the same product card and trigger it
      const productCard = quickviewIcon.closest('product-grid-item');
      if (productCard) {
        // Try to find quickview holder by product ID first
        let quickviewHolder = productCard.querySelector(`[data-quickview-holder="${productId}"]`);

        // If not found, try to find by handle (in case holder hasn't been updated yet)
        if (!quickviewHolder) {
          quickviewHolder = productCard.querySelector(`[data-product-handle="${productHandle}"]`);
        }

        // If still not found, find any quickview holder and update it
        if (!quickviewHolder) {
          quickviewHolder = productCard.querySelector('[data-quickview-holder]');
          if (quickviewHolder) {
            quickviewHolder.setAttribute('data-quickview-holder', productId);
            quickviewHolder.setAttribute('data-product-handle', productHandle);
          }
        } else {
          // Update the holder's attributes to match current product
          quickviewHolder.setAttribute('data-quickview-holder', productId);
          quickviewHolder.setAttribute('data-product-handle', productHandle);
        }

        if (quickviewHolder) {
          // Get Alpine component to ensure modal is initialized
          const alpineComponent = quickviewHolder.closest('[x-data*="productQuickViewButton"]');

          if (alpineComponent && alpineComponent.__x) {
            const alpineData = alpineComponent.__x.$data;

            // Ensure modal exists (Alpine creates it on init)
            if (!alpineData.modal) {
              alpineData.init();
            }

            // Find or get the modal
            let modal = document.getElementById(productId) ||
                       document.querySelector(`[data-quickview-modal][id="${productId}"]`) ||
                       document.querySelector(`.quickview__modal[id="${productId}"]`);

            // If modal still doesn't exist, create it from template immediately
            if (!modal && alpineData.modalTemplate) {
              const templateContent = alpineData.modalTemplate.innerHTML.trim();
              const cleanTemplate = templateContent.replace(/;$/, '');
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = cleanTemplate;
              modal = tempDiv.querySelector('.quickview__modal');

              if (modal) {
                modal.id = productId;
                document.body.appendChild(modal);
                // Update Alpine's modal reference
                alpineData.modal = modal;
              }
            }

            // Open modal immediately with loading state if it exists
            if (modal && typeof window.MicroModal !== 'undefined') {
              const modalContent = modal.querySelector('[data-product-quickview-ajax]');

              // Show loading state immediately
              if (modalContent && !modalContent.innerHTML.trim()) {
                modalContent.innerHTML = '<div style="padding: 40px; text-align: center; min-height: 200px; display: flex; align-items: center; justify-content: center;"><div style="display: inline-block; width: 40px; height: 40px; border: 3px solid rgba(0,0,0,0.1); border-top-color: #000; border-radius: 50%; animation: quickview-spin 0.6s linear infinite;"></div></div>';

                // Add spin animation if not already in CSS
                if (!document.getElementById('quickview-loading-style')) {
                  const style = document.createElement('style');
                  style.id = 'quickview-loading-style';
                  style.textContent = '@keyframes quickview-spin { to { transform: rotate(360deg); } }';
                  document.head.appendChild(style);
                }
              }

              // Open modal immediately (non-blocking)
              try {
                // Check if modal is already open
                const isAlreadyOpen = modal.classList.contains('is-open') ||
                                     modal.classList.contains('drawer--visible') ||
                                     modal.getAttribute('aria-hidden') === 'false';

                if (!isAlreadyOpen) {
                  MicroModal.show(productId, {
                    disableScroll: true,
                    awaitCloseAnimation: false
                  });
                }
              } catch (e) {
                // Modal might have issues, continue anyway
                console.debug('Quickview modal open attempt:', e);
              }
            }

            // Trigger Alpine to fetch and populate content
            // The modal is already open, so Alpine will just populate content
            if (alpineData.clickQuickviewButton) {
              // Call immediately - modal is already open with loading state
              alpineData.clickQuickviewButton(event);
            } else {
              // Fallback: click the button
              const quickviewButton = quickviewHolder.querySelector('button[type="button"]');
              if (quickviewButton) {
                quickviewButton.click();
              }
            }
          } else {
            // Fallback: just click the button if Alpine isn't available
            const quickviewButton = quickviewHolder.querySelector('button[type="button"]');
            if (quickviewButton) {
              quickviewButton.click();
            }
          }
        }
      }
    }

    // Return false as additional safeguard
    return false;
  }
}, true); // Use capture phase (true) to catch event before it bubbles

// @ts-nocheck
// @ts-ignore

class LazyVideo extends HTMLElement {
  constructor() {
    super();

    this._observer = null;
    this._videos = [];
    this._loaded = new WeakSet();
  }

  connectedCallback() {
    this._videos = Array.from(this.querySelectorAll('video'));

    if (!this._videos.length) return;

    this.setupVideos();
    this.createObserver();
    this._onResize = this.handleResize.bind(this);
    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    this._observer?.disconnect();
    window.removeEventListener('resize', this._onResize);
  }

  setupVideos() {
    this._videos.forEach(video => {
      video.preload = 'none';

      const source = video.querySelector('source');

      // Ensure no eager loading
      if (source?.src) {
        source.removeAttribute('src');
      }
    });
  }

  safePlay(video) {
    // Already playing → do nothing
    if (!video.paused) return;

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        // Ignore AbortError silently
      });
    }
  }

  safePause(video) {
    // Already paused → do nothing
    if (video.paused) return;
    video.pause();
  }

  handleResize() {
    this._videos.forEach(video => {
      if (!this.shouldLoad(video)) return;

      if (!this._loaded.has(video)) {
        this.loadVideo(video);
      }
    });
  }

  createObserver() {
    this._observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      {
        rootMargin: '200px',
        threshold: 0.1,
      }
    );

    this._observer.observe(this);
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this._videos.forEach(video => {
          if (!this.shouldLoad(video)) return;

          this.loadVideo(video);

          if (video.hasAttribute('autoplay')) {
            this.safePlay(video);
          }
        });
      } else {
        this._videos.forEach(video => {
          if (video.hasAttribute('autoplay')) {
            this.safePause(video);
          }
        });
      }
    });
  }

  shouldLoad(video) {
    const minAttr = video.getAttribute('min-width');
    const maxAttr = video.getAttribute('max-width');

    const hasMin = minAttr !== null;
    const hasMax = maxAttr !== null;

    const width = window.innerWidthCached;

    if (!hasMin && !hasMax) return true;

    const min = parseInt(minAttr, 10);
    const max = parseInt(maxAttr, 10);

    if (hasMin && !isNaN(min) && width < min) return false;
    if (hasMax && !isNaN(max) && width > max) return false;

    return true;
  }

  loadVideo(video) {
    if (this._loaded.has(video)) return;

    const source = video.querySelector('source');
    const src = source?.dataset?.src;

    if (!src) return;

    source.src = src;
    video.load();

    this._loaded.add(video);
  }
}

if (!customElements.get('lazy-video')) {
  customElements.define('lazy-video', LazyVideo);
}